'use strict';

var chunkR7NM4BVL_js = require('./chunk-R7NM4BVL.js');



module.exports = chunkR7NM4BVL_js.CartItem;
